import React, {Component} from "react";
import {Link, Redirect} from "react-router-dom";
import {Row,Col,FormGroup,FormLabel,FormControl} from "react-bootstrap";
import Card from "../../../components/Cards/Card/Card";
import Button from "../../../components/Common/KnoaButton";
import PropTypes from "prop-types";
import {API} from "lib/API";
import Spinner from "../../../components/Common/Spinner";
import {withTranslation} from 'react-i18next';
import Footer from "../../../components/Footer/Footer";
import CommonContainer from "../../../components/Common/CommonContainer";
import ModalDialog from "../../../components/Common/ModalDialog";
import {getSpecificOPErrorMessages} from "../../../lib/notifications/messageUtils";
import {Helmet} from "react-helmet";
import {notifyWithMessage} from "lib/notifications/notifyWithMessage";
import {clearNotifications} from "../../../lib/notifications/clearNotifications";

const localStorage = require('../../../lib/localStorage');
class ResetPassword extends Component {
  constructor(props) {
    super(props);

    this.verifyLength = this.verifyLength.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.isValidated = this.isValidated.bind(this);
    this.submitRequest = this.submitRequest.bind(this);
    this.parseURL = this.parseURL.bind(this);
    this.handleSubmitNewRequest = this.handleSubmitNewRequest.bind(this);
    this.validateToken = this.validateToken.bind(this);

    this.passwordInputOld = null;
    this.passwordInputNew = null;
    this.passwordInputConfirm = null;

    this.setPasswordInputOldRef = element => {
      this.passwordInputOld = element;
    };
    this.setPasswordInputNewRef = element => {
      this.passwordInputNew = element;
    };
    this.setPasswordInputConfirmRef = element => {
      this.passwordInputConfirm = element;
    };
    this.focusPasswordInputOld = () => {
      if (this.passwordInputOld) this.passwordInputOld.focus();
    };
    this.focusPasswordInputNew = () => {
      if (this.passwordInputNew) this.passwordInputNew.focus();
    };
      this.mainContent = React.createRef();

    this.state = {
      isPasswordExpired: !!(this.props.location.state && this.props.location.state.isPasswordExpired),
      email: (this.props.location.state && this.props.location.state.email) ? this.props.location.state.email : null,
      passwordMin: (this.props.location.state && this.props.location.state.passwordMin) ? this.props.location.state.passwordMin : -1,
      passwordMax: (this.props.location.state && this.props.location.state.passwordMax) ? this.props.location.state.passwordMax : -1,
      isFromSidebar: this.props.location.pathname === '/admin/password',
      passwordState: '',
      passwordOld: '',
      passwordNew: '',
      passwordConfirm: '',
      token: PropTypes.string,
      passwordErrorOld: null,
      passwordErrorNew: null,
      passwordErrorConfirm: null,
      transition: false,
      transitionTitle: PropTypes.string,
      transitionMessage: PropTypes.string,
      transitionMessageDiv: PropTypes.string,
      transitionIcon: PropTypes.string,
      transitionIconColor: PropTypes.string,
      submitNewRequest: false,
      loginRedirect: false,
      resetPasswordDisabled: true,
      fetchInProgress: "false",
      showLoggedoutModal: false,
      sessionTerminated: false
    }
  }

  resetValues() {
    this.setState({
      passwordState: '',
      passwordOld: '',
      passwordNew: '',
      passwordConfirm: '',
      resetPasswordDisabled: true
    });
    this.focusPasswordInputOld();
  }

  validateToken() {
    //valid, invalid_format, expired, invalid
    let tokenState = this.parseURL('valid');

    if (tokenState === 'valid') {
      let tokenValue = this.parseURL('token');
      this.setState({
        token: tokenValue,
        transitionTitle: 'Password Reset Successful',
        transitionMessage: 'Success! Your password has been changed.',
        transitionMessageDiv: 'transitionMessageDivSuccess',
        transitionIcon: 'pe-7s-check',
        transitionIconColor: 'forgotPassIconSuccess',
        transition: false
      });
    } else if (tokenState === '') {
      this.setState({loginRedirect: true});
    } else {
      let message = 'An unexpected error occurred! We\'ll need to re-send your authentication email. Please submit a new request to reset your password.';
      if (tokenState === 'expired') {
        message = 'Sorry, your token expired! We\'ll need to re-send your authentication email. Please submit a new request to reset your password.';
      }

      this.setState({
        transitionTitle: 'Password Reset Problem',
        transitionMessageDiv: 'transitionMessageDivProblem',
        transitionIcon: 'pe-7s-attention',
        transitionIconColor: 'forgotPassIconProblem',
        transitionMessage: message,
        transition: true
      });
    }
  }

  handleSubmitNewRequest() {
    this.setState({submitNewRequest: true});
  }

  parseURL(key) {
    let value = '';
    const search = this.props.location.search; //"?valid=valid&token=eyJpZ..."
    const items = search.split('&'); //["?valid=valid","token=eyJpZ..."]
    let indexStart;
    for(let i=0; i<items.length; i++){
      if(items[i].indexOf(key)!==-1){
        indexStart = items[i].indexOf(key + '=')+key.length+1;
        value = items[i].substring(indexStart);
        break;
      }
    }
    return value;
  }

  verifyLength = (value, length) => {
    return value.length >= length;
  };

  isValidated = () => {
    if (this.state.passwordState==='valid') {
      return true;
    } else {
      this.setState({passwordState: "invalid"});
      return false;
    }
  };

  submitRequest() {
    this.setState({fetchInProgress: "true"});

    let stringAPI;
    let objAPI = {};

    if(this.state.isPasswordExpired) {
      stringAPI = '/session/expiredPassword';
      objAPI.email = this.state.email;
      objAPI.oldPassword = this.state.passwordOld;
      objAPI.password = this.state.passwordNew;
    } else if(this.state.isFromSidebar) {
      stringAPI = '/user/v2/changePassword';
      objAPI.oldPassword = this.state.passwordOld;
      objAPI.password = this.state.passwordNew;
    } else {
      stringAPI = '/session/reset';
      objAPI.token = this.state.token;
      objAPI.password = this.state.passwordNew;
    }

    //Trim password if character size is greater than max
    if(objAPI.password.length > this.state.passwordMax) {
      objAPI.password = objAPI.password.substring(0,this.state.passwordMax);
    }
    if(objAPI.oldPassword && objAPI.oldPassword.length > this.state.passwordMax) {
      objAPI.oldPassword = objAPI.oldPassword.substring(0,this.state.passwordMax);
    }

    API.user
        .post(stringAPI, objAPI)
        .then(resp => {
          if(resp) {
              if(this.state.isFromSidebar) {
              if(localStorage.get("accessDenied401") === "true"){
                this.setState({showLoggedoutModal:true});
                return;
              }
              clearNotifications();
              notifyWithMessage({type: 'success', t: this.props.t, operation: 'generic', parameter: 'passwordChange', inSupport: true});
              this.resetValues();
            }
            else {
              clearNotifications();
              this.setState({
                transition: true
              });
            }
          }

          this.setState({fetchInProgress: localStorage.get("isLoading")});
        })
        .catch(e => {
          console.error(e);
          this.setState({fetchInProgress: localStorage.get("isLoading")});
          if(localStorage.get("accessDenied401") === "true" && this.state.isFromSidebar){
            this.setState({showLoggedoutModal:true});
            return;
          }

          let resultCode = -1;

          if(e.data) {
            resultCode = e.data.resultCode;
          }

          if(resultCode > -1)
            if(this.state.isFromSidebar) {
              clearNotifications();
              notifyWithMessage({type: "error", t: this.props.t, resultCode, isNormal: true});
            } else {
              clearNotifications();
              notifyWithMessage({type: "error", t: this.props.t, resultCode, isNormal: false});
            }
          else
          if(this.state.isFromSidebar) {
            clearNotifications();
            notifyWithMessage({type: "error", t: this.props.t, errorObject: e, isNormal: true});
          } else {
            clearNotifications();
            notifyWithMessage({type: "error", t: this.props.t, errorObject: e, isNormal: false});
          }
        });
  };

  handleLogoutConfirm = () =>{
    this.setState({sessionTerminated: true});
  };


  submitForm = e => {
    e.preventDefault();
    if (!this.isValidated()) return;
    this.submitRequest();
  };

  change = (event, stateName, type) => {
    let resetPasswordDisabled = true;
    if(type==='New' || type==='Confirm') {
      let state = 'invalid';
      let reason = null;
      let clearOther = false;
      let otherType = type === 'New' ? 'Confirm' : 'New';
      let otherValue = this.state[stateName + otherType];
      let minValue = this.state.passwordMin;
      let maxValue = this.state.passwordMax;

      //length verification
      if (this.verifyLength(event.target.value, minValue)) {
        //uppercase/lowercase/number/specialCharacter verification
        let otherIssues = [];
        let specialChars = RegExp('[!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~]');
        let targetValue = event.target.value;
        if(targetValue.length > maxValue){
          targetValue = targetValue.substring(0,maxValue);
        }

        if (!targetValue.match(/[A-Z]/g)) {
          otherIssues.push(this.props.t('validation:uppercaseLetter', {input: "1"}));
        }
        if (!targetValue.match(/[a-z]/g)) {
          otherIssues.push(this.props.t('validation:lowercaseLetter', {input: "1"}));
        }
        if (!targetValue.match(/[0-9]/g)) {
          otherIssues.push(this.props.t('validation:numberInput', {input: "1"}));
        }
        if (!specialChars.test(targetValue)) {
          otherIssues.push(this.props.t('validation:specialCharacter', {input: "1"}));
        }

        if (otherIssues.length > 0) {
          reason = this.props.t('validation:passwordIssues') + " " + otherIssues.join(', ');
        } else {
          //mismatch verification
          if (typeof (otherValue) === 'string' && this.verifyLength(otherValue, minValue)) {
            if (event.target.value !== otherValue) {
              reason = this.props.t('validation:passwordMismatch');
              clearOther = true;
            } else {
              state = 'valid';
              if((typeof (this.state.passwordOld) === 'string' && this.verifyLength(this.state.passwordOld, 1)) || ((!this.state.isPasswordExpired && !this.state.isFromSidebar))){
                resetPasswordDisabled = false;
              }
            }
          }
        }
      } else if (this.verifyLength(event.target.value, 1)) {
        reason = this.props.t('validation:passwordLength', {input: minValue});
        if (typeof (otherValue) === 'string' && this.verifyLength(otherValue, minValue) && event.target.value !== otherValue) {
          clearOther = true;
        }
      }

      this.setState({
        [stateName + "State"]: state,
        ['passwordError' + type]: !reason ? null : (
            <small
                className="text-danger"
                id={`${stateName}${type}Error`}
                aria-live="polite"
            >
              {reason}
            </small>
        ),
        [stateName + type]: event.target.value,
        ['passwordError' + otherType]: (clearOther || typeof (otherValue) !== 'string') ? null : this.state['passwordError' + otherType],
        resetPasswordDisabled: resetPasswordDisabled
      });
    } else if(type==='Old') {
      if (this.verifyLength(event.target.value, 1) && this.state[stateName + "State"]==='valid') {
        resetPasswordDisabled = false;
      }

      this.setState({
        [stateName + type]: event.target.value,
        resetPasswordDisabled: resetPasswordDisabled
      });
    }
  };

  componentDidMount() {
    if(!this.state.isPasswordExpired) {
      //CASE 1: User changes password from inside app
      if(this.state.isFromSidebar) {
        let minPassLength = -1;
        let maxPassLength = -1;
        API.user
          .get('/user/passwordLengthSetting')
          .then(resp => {
            const {data} = resp.data;
            minPassLength = data.min;
            maxPassLength = data.max;

            this.setState({
              passwordMin: minPassLength,
              passwordMax: maxPassLength
            });
          })
          .catch(e => {
            console.error(e);

            let resultCode = -1;
            if (e.data) {
              resultCode = e.data.resultCode;
            }

            if (resultCode > -1) {
              notifyWithMessage({type: 'error', t: this.props.t, resultCode, isNormal: true});
            } else {
              notifyWithMessage({type: 'error', t: this.props.t, errorObject: e, isNormal: true});
            }
          })
      } else {
        //CASE 2: User resets password via EMAIL
        let passMin = this.parseURL("min");
        let passMax = this.parseURL("max");

        this.setState({
          passwordMin: passMin,
          passwordMax: passMax
        });

        this.validateToken();
        this.focusPasswordInputNew();
      }
    } else {
      //CASE 3: User's password is expired
      this.setState({
        transitionTitle: 'Password Reset Successful',
        transitionMessage: 'Success! Your password has been changed.',
        transitionMessageDiv: 'transitionMessageDivSuccess',
        transitionIcon: 'pe-7s-check',
        transitionIconColor: 'forgotPassIconSuccess'
      });
      clearNotifications();
      notifyWithMessage({type: "error", message: "Logon failure: The password has expired or no longer meets the password requirement. Please choose a new password."});
      this.focusPasswordInputOld();
    }

    if(this.mainContent && this.mainContent.current) {
      this.mainContent.current.focus({ preventScroll: true });
    }
  }

  render() {
    if(this.state.sessionTerminated)
      return <Redirect to={{pathname: '/auth/logout'}}/>;
    else if(this.state.submitNewRequest){
      return <Redirect to={{pathname: '/auth/forgotPassword'}}/>
    } else if(this.state.loginRedirect){
      return <Redirect to={{pathname: '/auth/login'}}/>
    }

    const {transitionTitle, transitionIcon, transitionIconColor, transitionMessageDiv, transitionMessage, transition, passwordErrorOld, passwordErrorNew, passwordErrorConfirm, passwordState, isPasswordExpired, resetPasswordDisabled, isFromSidebar, passwordMin, passwordMax} = this.state;

    const footerObj = [];
    if(isFromSidebar) {
      const updatePasswordObj = {
        name: this.props.t('common:save'),
        callback: this.submitForm,
        disabled:resetPasswordDisabled
      };
      footerObj.push(updatePasswordObj);
    }

    return (
        <div className={isFromSidebar ? null : 'container'}>
          <Helmet>
            {isFromSidebar &&<title>Knoa Analytics - Password</title>}
            {!isFromSidebar &&<title>Knoa Analytics - Reset Password</title>}
          </Helmet>
          {isFromSidebar && this.state.showLoggedoutModal && (
          <ModalDialog
              showModal={this.state.showLoggedoutModal}
              modalID="mResetLogOut"
              title={"Log Out"}
              contentBody={
                <span>{getSpecificOPErrorMessages(this.props.t,"logoutfor401",null,null)}</span>
              }
              bodyPaddingBottom='15px'
              footerBtnBsStyle="success"
              footerBtnClass="KnoaSuccessButton"
              footerBtnOnClick={this.handleLogoutConfirm}
              footerBtnText={this.props.t('common:ok')}
          />
          )}
          <Col
              md={isFromSidebar ? null : { span: 4, offset: 4 }}
              sm={isFromSidebar ? null : { span: 6, offset: 3 }}
          >
            {!transition ? (
                <form onSubmit={this.submitForm}>
                  <div className={isFromSidebar ? "main-content main-content-page-with-footer" : null} ref={isFromSidebar ? this.mainContent : null} tabIndex={"-1"}>
                    {this.state.fetchInProgress  === "true" && <Spinner/>}
                    <div hidden={this.state.fetchInProgress  === "true"}>
                      <CommonContainer className={isFromSidebar ? "common-page-content-row" : null}>
                          <Col className="knoa-region" tabIndex={"-1"}>
                            <Card
                                textCenter={!isFromSidebar}
                                title={isFromSidebar ? this.props.t('common:changePassword') : "Reset Password"}
                                content={
                                  <div className={isFromSidebar ? null : 'resetPasswordInfo'}>
                            <span
                                className='forgotPassInfo'>{this.props.t('messages.item:passwordComplexityTitle')}</span>
                                    <ul className='resetPasswordList'>
                                      <li>{this.props.t('messages.item:passwordComplexityLength', {min: passwordMin, max: passwordMax})}</li>
                                      <li>{this.props.t('validation:containAtLeast', {key: "uppercaseLetter", input: "1"})}</li>
                                      <li>{this.props.t('validation:containAtLeast', {key: "lowercaseLetter", input: "1"})}</li>
                                      <li>{this.props.t('validation:containAtLeast', {key: "numberInput", input: "1"})}</li>
                                      <li>{this.props.t('validation:containAtLeast', {key: "specialCharacter", input: "1"})}</li>
                                      <li>{this.props.t('validation:passwordHistoryInfo')}</li>
                                    </ul>
                                    {(isPasswordExpired || isFromSidebar) &&
                                    <FormGroup>
                                      <FormLabel htmlFor="currentPassword">{this.props.t('common:currentPassword')} <span className="text-danger-1">*</span></FormLabel>
                                      <Row className={isFromSidebar ? null : 'cardRowPad'}>
                                        <Col xs={isFromSidebar ? 8 : null} sm={isFromSidebar ? 6 : null}>
                                          <FormControl
                                              value={this.state.passwordOld}
                                              placeholder={this.props.t('common:currentPassword')}
                                              type="password"
                                              autoComplete="off"
                                              onChange={e => this.change(e, "password", "Old")}
                                              ref={this.setPasswordInputOldRef}
                                              className={isFromSidebar ? 'passField' : null}
                                              name="currentPassword"
                                              id="currentPassword"
                                              aria-required="true"
                                              aria-invalid={!!this.state.passwordErrorOld}
                                              aria-describedby={this.state.passwordErrorOld ? "passwordOldError" : undefined}
                                          />
                                          {passwordErrorOld}
                                        </Col>
                                      </Row>
                                    </FormGroup>
                                    }
                                    <FormGroup>
                                      <FormLabel htmlFor="newPassword">{this.props.t('common:newPassword')} <span className="text-danger-1">*</span></FormLabel>
                                      <Row className={isFromSidebar ? null : 'cardRowPad'}>
                                        <Col xs={isFromSidebar ? 8 : null} sm={isFromSidebar ? 6 : null}>
                                          <FormControl
                                              value={this.state.passwordNew}
                                              placeholder={this.props.t('common:newPassword')}
                                              type="password"
                                              autoComplete="off"
                                              onChange={e => this.change(e, "password", "New")}
                                              ref={this.setPasswordInputNewRef}
                                              className={isFromSidebar ? 'passField' : null}
                                              name="newPassword"
                                              id="newPassword"
                                              aria-required="true"
                                              aria-invalid={!!this.state.passwordErrorNew}
                                              aria-describedby={this.state.passwordErrorNew ? "passwordNewError" : undefined}
                                          />
                                          {passwordErrorNew}
                                        </Col>
                                      </Row>
                                    </FormGroup>
                                    <FormGroup>
                                      <FormLabel htmlFor="confirmNewPassword">{this.props.t('common:confirmNewPassword')} <span className="text-danger-1">*</span></FormLabel>
                                      <Row className={isFromSidebar ? null : 'cardRowPad'}>
                                        <Col xs={isFromSidebar ? 8 : null} sm={isFromSidebar ? 6 : null}>
                                          <FormControl
                                              value={this.state.passwordConfirm}
                                              placeholder={this.props.t('common:confirmPassword')}
                                              type="password"
                                              autoComplete="off"
                                              onChange={e => this.change(e, "password", "Confirm")}
                                              ref={this.setPasswordInputConfirmRef}
                                              className={isFromSidebar ? 'passField' : null}
                                              name="confirmNewPassword"
                                              id="confirmNewPassword"
                                              aria-required="true"
                                              aria-invalid={!!this.state.passwordErrorConfirm}
                                              aria-describedby={this.state.passwordErrorConfirm ? "passwordConfirmError" : undefined}
                                          />
                                          {passwordErrorConfirm}
                                        </Col>
                                      </Row>
                                    </FormGroup>
                                  </div>
                                }
                                legend={!isFromSidebar &&
                                <>
                                  <Button
                                      disabled={resetPasswordDisabled}
                                      variant="info"
                                      className='btn-fill'
                                      type="submit">
                                    Reset Password
                                  </Button>
                                  <br></br>
                                  <Link className='loginLink' to={{pathname: "/auth/login"}}>Cancel</Link>
                                </>
                                }
                                ftTextCenter
                                custom='resetPasswordCard'
                                contentClass={isFromSidebar ? 'cardContent' : null}
                            />
                          </Col>
                      </CommonContainer>
                    </div>
                    {isFromSidebar &&
                    <Footer fluid footerObj={footerObj}/>
                    }
                  </div>
                </form>
            ) : (
                <Card
                    textCenter
                    title={transitionTitle}
                    content={
                      <div>
                        <div className='forgotPassIconDiv'><i className={transitionIcon + ' ' + transitionIconColor} /></div>
                        <div className={transitionMessageDiv}>
                          <span>{transitionMessage}</span>
                        </div>
                      </div>
                    }
                    legend={
                      <>
                        {passwordState!=='valid' &&
                        <>
                          <Button
                              type="submit"
                              onClick={this.handleSubmitNewRequest}>
                            Submit new request
                          </Button>
                        </>
                        }
                        <br></br>
                        <Link className='loginLink' to={{pathname: "/auth/login"}}>Return to login</Link>
                      </>
                    }
                    ftTextCenter
                />
            )
            }
          </Col>
        </div>
    );
  }
}

export default withTranslation()(ResetPassword);